module.exports = __webpack_public_path__ + "img/email.a34f8fb2.svg";